import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, zip } from 'rxjs';
import { HubItemState } from './hub-item.state';
import {
  HubItemChangeActiveState,
  HubItemCreate,
  HubItemDelete,
  HubItemInitialState,
  HubItemNewSsccId,
  HubItemSetId,
} from './hub-item.actions';
import { SetInitialStateFacade } from '../../../../../common/models';
import { HubOverview } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { PERMISSION_CONFIG, Permission } from '../../../../../common/constants/permissions';
import { map, take } from 'rxjs/operators';
import { AuthFacade } from '../../../auth';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class HubItemFacade implements SetInitialStateFacade {
  hubId$: Observable<number> = this.store.select(HubItemState.getHubId);
  newSsccId$: Observable<number> = this.store.select(HubItemState.getSscdIdForNewHub);

  hasPermissionToCreateHub$ = zip(
    this.authFacade.hasPermission$(
      PERMISSION_CONFIG[Permission.DockAndYard][Permission.LocationManagement][Permission.Hubs][Permission.Update],
    ),
    this.authFacade.hasPermission$(
      PERMISSION_CONFIG[Permission.DockAndYard][Permission.LocationManagement][Permission.Hubs][Permission.Create],
    ),
  ).pipe(
    take(1),
    map(([update, create]: [boolean, boolean]) => update && create),
  );

  hasPermissionToUpdateHub$ = this.authFacade.hasPermission$(
    PERMISSION_CONFIG[Permission.DockAndYard][Permission.LocationManagement][Permission.Hubs][Permission.Update],
  );

  constructor(private store: Store, private authFacade: AuthFacade) {}

  setHubId(id: number): void {
    this.store.dispatch(new HubItemSetId(id));
  }

  createHub(hubData: HubOverview): void {
    this.store.dispatch(new HubItemCreate(hubData));
  }

  deleteHub(hubId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new HubItemDelete({ hubId, dialog }));
  }

  changeActiveHubState(hubId: number, enable: boolean): void {
    this.store.dispatch(new HubItemChangeActiveState({ hubId, enable }));
  }

  getSsccIdForNewHub(): void {
    this.store.dispatch(new HubItemNewSsccId());
  }

  setInitialState(): void {
    this.store.dispatch(new HubItemInitialState());
  }
}
